import React, {Component} from 'react';
import ReactDOM from 'react-dom';

import { Layout, MinMaxLayout } from '../../layouts';

// Design system components

import Textarea from '../../components/textarea-with-label';
import Input from '../../components/input-with-label';
import InputCurrency from '../../components/input-currency';
import Dropdown from '../../components/dropdowns/dropdown';
import Checkbox from '../../components/checkbox';
import RadioButton from '../../components/radio-button';
import Table from '../../components/table/table';
import InputDate from '../../components/input-date';
import FileUpload from '../../components/file-upload';

import { CreateButton, UploadButton, DeleteButton, ViewButton, ChangeButton } from '../../components/buttons';

function Section({ title, children, style, contentStyle  }) {
    return (
        <div className="section" style={style}>
            <p className="section__title">{ title }</p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', ...contentStyle }}>
                { children }
            </div>
        </div>
    )
}

function ListOfComponents() {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '36px' }}>
            <Section title="Text input Field - small">
                <div className="utils__row utils__gap--20">
                    <Input label="Field Label" placeholder="Input Value" fit={true} />
                    <Input label="Field Label" placeholder="Input Value" fit={true} />
                    <Input label="Field Label" placeholder="Input Value" fit={true} errors={['This field must not be left blank']}/>
                </div>
            </Section>

            <Section title="Text input Field - large">
                <Input label="Field Label" placeholder="Input Value" fit={true} />
                <Input label="Field Label" placeholder="Input Value" fit={true} />
                <Input label="Field Label" placeholder="Input Value" fit={true} errors={['This field must not be left blank']}/>
            </Section>

            <Section title="Text input Field - Word Count">
                <Textarea label="Field Label" placeholder="Input Value" right="Min. 100 words | 0/200"/>
                <Textarea label="Field Label" placeholder="Input Value" right="Min. 100 words | 0/200"/>
                <Textarea label="Field Label" placeholder="Input Value" right="Min. 100 words | 0/200" error={['This field must not be left blank']}/>
            </Section>

            <Section title="Currency Input">
                <div className="utils__row utils__gap--20">
                    <InputCurrency label="Field Label" placeholder="Input Value" fit={true}/>
                    <InputCurrency label="Field Label" placeholder="Input Value" fit={true}/>
                    <InputCurrency label="Field Label" placeholder="Input Value" fit={true} error='This field must not be left blank'/>
                </div>
            </Section>

            <Section title="Dropdown Field">
                <div className="utils__row utils__gap--20">
                    <Dropdown label="List Label"  placeholder="Please select" fit={true} error="Please select an option to proceed"/>
                    <Dropdown label="List Label"  placeholder="Please select" fit={true} opened={true} items={[
                        {
                            label: 'List Item result 1 name',
                            value: 0,
                        },
                        {
                            label: 'List Item result 2 name',
                            value: 0,
                        },
                        {
                            label: 'List Item result 3 name',
                            value: 0,
                        }
                    ]}/>
                    <Dropdown label="List Label"  placeholder="Please select" fit={true} value={{ label: 'List Item result 1 name', value: 0 }}/>
                </div>
            </Section>

            <Section title="Document Upload" style={{ marginTop: '120px' }}>
                <FileUpload />

                <div className="document-upload__outer">
                    <div className="document-upload__container">
                        <div className="document-upload document-upload--successfull">
                            <img src="/assets/document.svg" />
                        </div>
                        <p className="document-upload__file">guidance_for…pdf</p>
                    </div>
                    <div className="document-upload__inner">
                        <DeleteButton />
                        <ChangeButton/>
                        <p className="document-upload-inner__text">Files must be below 2mb</p>
                    </div>
                </div>   
            </Section>

            <Section title="Checkboxes (Multiple Choice)" contentStyle={{ display: 'flex', flexDirection: 'column', gap: '40px' }}>
                <div className="utils__row utils__gap--20" style={{ gap: '150px' }}>
                    <Checkbox text="Checkbox label"/>
                    <Checkbox text="Checkbox label"/>
                    <Checkbox text="Checkbox label"/>
                    <Checkbox text="Checkbox label"/>
                </div>
                <div className="utils__row utils__gap--20" style={{ gap: '150px' }}>
                    <Checkbox text="Checkbox label"/>
                    <Checkbox text="Checkbox label" checked={true}/>
                    <Checkbox text="Checkbox label" checked={true}/>
                    <Checkbox text="Checkbox label"/>
                </div>
                <div className="utils__row utils__gap--20" style={{ gap: '150px' }}>
                    <Checkbox text="Checkbox label" error="Please check this box to proceed"/>
                </div>
                <div className="utils__row utils__gap--20" style={{ gap: '150px' }}>
                    <Checkbox text="Checkbox label" error="Please check one of the boxes to proceed"/>
                    <Checkbox text="Checkbox label"/>
                    <Checkbox text="Checkbox label"/>
                    <Checkbox text="Checkbox label"/>
                </div>
                <div className="utils__row utils__gap--20" style={{ gap: '150px' }}>
                    <RadioButton text="Checkbox label"/>
                    <RadioButton text="Checkbox label"/>
                    <RadioButton text="Checkbox label"/>
                    <RadioButton text="Checkbox label"/>
                </div>
                <div className="utils__row utils__gap--20" style={{ gap: '150px' }}>
                    <RadioButton text="Checkbox label"/>
                    <RadioButton text="Checkbox label" checked={true}/>
                    <RadioButton text="Checkbox label"/>
                    <RadioButton text="Checkbox label"/>
                </div>
                <div className="utils__row utils__gap--20" style={{ gap: '150px' }}>
                    <RadioButton text="Checkbox label" error="Please check this box to proceed"/>
                    <RadioButton text="Checkbox label" checked={true}/>
                    <RadioButton text="Checkbox label"/>
                    <RadioButton text="Checkbox label"/>
                </div>
            </Section>

            <Section title="Table" contentStyle={{ display: 'flex', flexDirection: 'column', gap: '40px' }}>
                <Table/>
                <Table error="Please complete all required fields to proceed"/>
                <Table addRowButton={true}/>
            </Section>

            <Section title="Date Picker">
                <div className="utils__row utils__gap--20" style={{ gap: '150px' }}>
                    <InputDate/>
                    <InputDate type="multi"/>
                </div>
            </Section>
        </div>
    )
}

class Components extends Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        
    }

    render() {
        return (
            <Layout>
                <MinMaxLayout main={<ListOfComponents />}/>
            </Layout>
        )
    }
}

const el = document.getElementById('components');

if (el) {
    ReactDOM.render(<Components/>, el);
}
